<template>
    <el-container v-if="pageInfo">
        <slot name="page_tips"></slot>
        <slot name="extra_html"></slot>
        <slot name="header_tabs"></slot>
        <el-header class="toolbar-btn-action">
            <div class="left-panel">
                <template v-for="(item, index) in pageInfo.top_buttons" :key="index">
                    <el-button :type="item.type" @click="topBut(item.name, item.href)">
                        <ui-icon v-if="item.icon" :type="item.icon" />
                        <text class="title">{{ item.title }}</text>
                    </el-button>
                </template>
            </div>
            <div class="right-panel">
                <div class="right-panel-search">
                    <template v-if="Object.keys(pageInfo.select_list).length > 0">
                        <template v-for="(item, index) in pageInfo.select_list" :key="index">
                            <cascader
                                class="toolbar-se-cascader"
                                clearable
                                v-model="selectList[index]"
                                :attr="item.attr"
                                :config="item.config"
                                :form-options="item.options" />
                        </template>
                    </template>
                    <template v-if="Object.keys(pageInfo.filter_time).length > 0">
                        <div class="toolbar-date-picker">
                            <el-date-picker
                                v-model="filterTimeVal"
                                @change="filterTime"
                                type="daterange"
                                format="YYYY-MM-DD"
                                value-format="YYYY-MM-DD"
                                :start-placeholder="pageInfo.filter_time.tips_start"
                                :end-placeholder="pageInfo.filter_time.tips_end"
                                :default-value="defaultTime"
                            />
                        </div>
                    </template>
                    <template v-if="pageInfo.search.length > 0">
                        <el-input v-model="keyword" placeholder="请输入搜索内容" class="input-with-select">
                            <template v-if="pageInfo.search" #prepend>
                                <el-select v-model="searchField" placeholder="请选择" style="width: 80px">
                                    <el-option v-for="(item, index) in pageInfo.search" :key="index" :label="item.title" :value="item.field" />
                                </el-select>
                            </template>
                            <template #append>
                                <el-button class="search-btn" @click="topSearch">
                                    <ui-icon type="search" size="25" />
                                </el-button>
                            </template>
                        </el-input>
                    </template>
                </div>
            </div>
        </el-header>
        <el-main class="nopadding">
            <div style="height: 100%;">
                <div :style="{'height': tableheight}">
                    <el-table
                        :data="dataList"
                        :tree-props="pageInfo.table_config.tree_props ? pageInfo.table_config.tree_props : {}"
                        class="data-table"
                        :stripe="pageInfo.table_config.stripe === false ? false : true"
                        :border="pageInfo.table_config.border === false ? false : true"
                        :default-expand-all="pageInfo.table_config.default_expand_all === false ? false : true"
                        :row-key="pageInfo.table_config.row_key ? pageInfo.table_config.row_key : 'id'"
                        style="width: 100%"
                        :height="height == 'auto' ? null : '100%'"
                        @selection-change="handleSelectionChange"
                        @sort-change="sortChange">
                        <slot></slot>
                        <template v-if="pageInfo.columns">
                            <el-table-column class="table-checkbox" v-if="pageInfo.is_checkbox" fixed type="selection" width="40" />
                            <el-table-column
                                v-for="(item, index) in pageInfo.columns"
                                :key="index"
                                :prop="item.name"
                                :label="item.title"
                                :sortable="Object.keys(pageInfo.order_columns).includes(item.name) ? 'custom' : false"
                                :fixed="ismobile ? false : item.fixed"
                                :width="item.width">
                                <template v-if="item.type === 'btn'" #default="scope">
                                    <el-button-group>
                                        <template v-for="(item_r, index_r) in pageInfo.right_buttons" :key="index_r">
                                            <el-button
                                                size="small"
                                                v-if="Object.keys(scope.row.no_right_button).length <= 0 || (Object.keys(scope.row.no_right_button).length > 0 && !scope.row.no_right_button.includes(item_r.name.toLowerCase()))"
                                                :type="item_r.type"
                                                @click="nodeBut(item_r.name, scope.row, item_r.href)">
                                                <ui-icon v-if="item_r.icon" :type="item_r.icon" />
                                                <span v-else>{{ item_r.title }}</span>
                                            </el-button>
                                        </template>
                                    </el-button-group>
                                </template>

                                <template v-else-if="item.type === 'switch'" #default="scope">
                                    <el-switch v-model="scope.row[item.name]" :active-value="1" :inactive-value="0" size="small" @change="nodeSwitchChange(scope.row.id, scope.row[item.name], item.name)" />
                                </template>

                                <template v-else-if="item.type === 'status'" #default="scope">
                                    <el-tag class="mx-1" size="small" :type="scope.row[item.name].tag">
                                        {{ scope.row[item.name]['title'] }}
                                    </el-tag>
                                </template>

                                <template v-else-if="item.type === 'yesno'" #default="scope">
                                    <ui-icon v-if="scope.row[item.name]" type="seleted" color="#46c37b" size="18" />
                                    <ui-icon v-else type="close" color="#d26a5c" size="18" />
                                </template>

                                <template v-else-if="item.type === 'picture'" #default="scope">
                                    <el-image lazy style="width: 50px;" :src="getImgUrl(scope.row[item.name].image_thumb)" fit="scale-down" @click="toweb(getImgUrl(scope.row[item.name].image_path))" />
                                </template>
                                <template v-else-if="item.type === 'pictures'" #default="scope">
                                    <template v-for="(img, img_index) in scope.row[item.name]" :key="img_index">
                                        <el-image lazy style="width: 50px;" :src="getImgUrl(img.image_thumb)" fit="scale-down" @click="toweb(getImgUrl(img.image_path))" />
                                    </template>
                                </template>
                                <template v-else-if="item.type === 'text.edit' || item.type === 'textarea.edit'" #default="scope">
                                    <el-popover :visible="!scope.row[item.name].is_show" placement="top" :width="'aotu'">
                                        <div>
                                            <template v-if="item.type == 'text.edit'">
                                                <el-input v-model="scope.row[item.name].text" @change="scope.row[item.name].is_show = true; nodeQuickEdit(scope.row.id, scope.row[item.name].text, item.name)" />
                                            </template>
                                            <template v-if="item.type == 'textarea.edit'">
                                                <el-input v-model="scope.row[item.name].text" :rows="2" type="textarea" @change="scope.row[item.name].is_show = true; nodeQuickEdit(scope.row.id, scope.row[item.name].text, item.name)" />
                                            </template>
                                        </div>
                                        <div style="text-align: right; margin-top: 5px">
                                            <el-button size="small" text @click="scope.row[item.name].is_show = true">取消</el-button>
                                        </div>
                                        <template #reference>
                                            <div class="table-edit-item" @click="scope.row[item.name].is_show = false">
                                                <ui-icon type="editor1" color="#1F98CA" size="18" />
                                                <text v-html="scope.row[item.name].text" />
                                            </div>
                                        </template>
                                    </el-popover>
                                </template>

                                <template v-else-if="item.type === 'date.edit' || item.type === 'time.edit' || item.type === 'datetime.edit'" #default="scope">
                                    <el-popover :visible="!scope.row[item.name].is_show" placement="top" :width="'aotu'">
                                        <div>
                                            <template v-if="item.type == 'time.edit'">
                                                <el-time-picker v-model="scope.row[item.name].text" @change="scope.row[item.name].is_show = true;nodeQuickEdit(scope.row.id, scope.row[item.name].text, item.name)" :format="scope.row[item.name].format" :value-format="scope.row[item.name].format" />
                                            </template>
                                            <template v-if="item.type == 'date.edit' || item.type == 'datetime.edit'">
                                                <el-date-picker
                                                    v-model="scope.row[item.name].text"
                                                    @change="scope.row[item.name].is_show = true; nodeQuickEdit(scope.row.id, scope.row[item.name].text, item.name)"
                                                    :format="scope.row[item.name].format"
                                                    :value-format="scope.row[item.name].format"
                                                    :type="scope.row[item.name].type" />
                                            </template>
                                        </div>
                                        <div style="text-align: right; margin-top: 5px">
                                            <el-button size="small" text @click="scope.row[item.name].is_show = true">取消</el-button>
                                        </div>
                                        <template #reference>
                                            <div class="table-edit-item" @click="scope.row[item.name].is_show = false">
                                                <ui-icon type="editor1" color="#1F98CA" size="18" />
                                                <text v-html="scope.row[item.name].text" />
                                            </div>
                                        </template>
                                    </el-popover>
                                </template>

                                <template v-else-if="item.type === 'select'" #default="scope">
                                    <el-popover :visible="!scope.row[item.name].is_show" placement="top" :width="'aotu'">
                                        <div>
                                            <el-select v-model="scope.row[item.name].value" placeholder="请选择" @change="scope.row[item.name].is_show = true; nodeQuickEdit(scope.row.id, scope.row[item.name].value, item.name)">
                                                <template v-for="(options_item, options_index) in scope.row[item.name].options" :key="options_index">
                                                    <el-option
                                                        :label="options_item"
                                                        :value="typeof(scope.row[item.name].value) == 'number' ? parseInt(options_index) : options_index">
                                                        <text>{{ options_item }}</text>
                                                    </el-option>
                                                </template>
                                            </el-select>
                                        </div>
                                        <div style="text-align: right; margin-top: 5px">
                                            <el-button size="small" text @click="scope.row[item.name].is_show = true">取消</el-button>
                                        </div>
                                        <template #reference>
                                            <div class="table-edit-item" @click="scope.row[item.name].is_show = false">
                                                <ui-icon type="editor1" color="#1F98CA" size="18" />
                                                <text v-html="scope.row[item.name].text" />
                                            </div>
                                        </template>
                                    </el-popover>
                                </template>

                                <template v-else-if="item.type === 'icon'" #default="scope">
                                    <ui-icon v-if="scope.row[item.name]" :type="scope.row[item.name]" size="18" />
                                </template>
                                <template v-else-if="item.type === 'file'" #default="scope">
                                    <el-image v-if="scope.row.is_image" lazy style="width: 50px;" :src="getImgUrl(scope.row.image_thumb)" fit="scale-down" @click="toweb(getImgUrl(scope.row.file))" />
                                    <template v-else>
                                        <div @click="toweb(getImgUrl(scope.row.file))">
                                            <ui-icon v-if="scope.row.ext === 'xls' || scope.row.ext === 'xlsx'" size="50" type="xlsx" />
                                            <ui-icon v-else-if="scope.row.ext === 'pdf'" size="50" type="pdf-fill" />
                                            <ui-icon v-else-if="scope.row.ext === 'doc' || scope.row.ext === 'docx'" size="50" type="docjpge-fill" />
                                            <ui-icon v-else size="50" type="manage-order" />
                                        </div>
                                    </template>
                                </template>
                                <template v-else #default="scope">
                                    <text v-html="scope.row[item.name]" />
                                </template>
                            </el-table-column>
                        </template>
                        <template #empty>
                            <el-empty description="暂无数据" :image-size="100"></el-empty>
                        </template>
                    </el-table>
                </div>
                <div class="table-page-box" v-if="pageInfo.pages.per_page > 0">
                    <div class="pagination-box">
                        <el-pagination small background :page-sizes="[10, 15, 20, 30, 50, 100]" :page-size="pageInfo.pages.per_page" :layout="ismobile ? 'prev, pager, next' : 'prev, pager, next, total, sizes, jumper'" :total="pageInfo.pages.total" @update:pageSize="PageSizeChange" @update:currentPage="toPage" />
                    </div>
                </div>
            </div>
        </el-main>
    </el-container>
</template>

<script>
    import { defineComponent, getCurrentInstance, ref, provide, inject, watch, computed, reactive } from 'vue'
    import { useLayoutStore } from '@/store'
    import Utils from '@/utils/util'
    import Cascader from '../ui-form-page/items/cascader'
    export default defineComponent({
        components: {
            Cascader
        },
        props: {
            pageInfo: {
                type: Object || Array,
                default: () => { }
            }
        },
        setup(props, context) {
            const StoreLayout = useLayoutStore()
            const getImgUrl = Utils.getImgUrl
            const dataList = inject('dataList')
            const searchField = ref()
            const keyword = ref()
            const ismobile = computed(() => StoreLayout.ismobile)
            if (props.pageInfo.search && props.pageInfo.search[0] && props.pageInfo.search[0].field) {
                searchField.value = props.pageInfo.search[0].field
            }
            const topSearch = () => {
                context.emit('update:topSearch', searchField, keyword)
            }

            const topBut = (e, href) => {
                context.emit('update:topBut', e, href)
            }
            const nodeBut = (e, a, href) => {
                context.emit('update:nodeBut', e, a, href)
            }

            const PageSizeChange = (e) => {
                context.emit('update:PageSizeChange', e)
            }
            const toPage = (e) => {
                context.emit('update:toPage', e)
            }
            const handleSelectionChange = (e) => {
                context.emit('update:handleSelectionChange', e)
            }
            const sortChange = (e) => {
                let obj = {}
                obj[e.prop] = e.order
                context.emit('update:sortChange', obj)
            }
            const toweb = (url) => {
                if (url != null) window.open(url)
            }

            const nodeSwitchChange = (a, b, c) => {
                context.emit('update:nodeSwitchChange', a, b, c)
            }

            const nodeQuickEdit = (a, b, c) => {
                context.emit('update:nodeQuickEdit', a, b, c)
            }
            
            const defaultTime = ref([])
            const filterTimeVal = ref()
            if (props.pageInfo.filter_time.date_start && props.pageInfo.filter_time.date_end) {
                defaultTime.value.push(props.pageInfo.filter_time.date_start, props.pageInfo.filter_time.date_end)
            } else if (props.pageInfo.filter_time.date_start && !props.pageInfo.filter_time.date_end) {
                defaultTime.value.push(props.pageInfo.filter_time.date_start)
            }
            const filterTime = (e) => {
                context.emit('update:filterTime', e)
            }

            const selectList = ref([])
            for (let i in props.pageInfo.select_list) {
                selectList.value[i] = [props.pageInfo.select_list[i].default]
                watch(
                    () => selectList.value[i],
                    (newv, oldv) => {
                        if (!newv && newv !== 0) newv = 'all'
                        context.emit('update:selectList', i, newv)
                    },
                    { deep: true }
                )
            }

            let pageConfig = reactive({
                pageheight: 0,
                tableheight: 0
            })
            const tableheight = ref(props.pageInfo.pages.per_page > 0 ? 'calc(100% - 50px)' : '100%')
            return {
                ismobile,
                dataList,
                searchField,
                keyword,
                defaultTime,
                filterTimeVal,
                selectList,

                topSearch,
                topBut,

                nodeBut,
                nodeQuickEdit,
                nodeSwitchChange,

                PageSizeChange,
                toPage,

                handleSelectionChange,
                sortChange,
                filterTime,

                getImgUrl,
                toweb,

                tableheight
            }
        }
    })
</script>

<style>
    .table-edit-item{
        color: rgb(31, 152, 202);
    }
    .table-edit-item:hover{
        cursor: pointer;
    }
    .data-table .el-table__placeholder{ width: 0;}

    .table-page-box {height:50px;display: flex;align-items: center;justify-content: space-between;padding:0 15px; border-top: 1px solid #ebeef5}
</style>
